import React, {useState} from 'react';
import {Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {toastHelper} from '../../../utils/toast-helper';
import {useImporterSimulationMutation} from '../../../modules/simulations/simulations.api';
import {erreurFichierImport, formDataImport, importerScenario} from './echangeScenarioRules';

/** Modale « Importer un scénario » : fichier .json ≤ 5 Mo → POST multipart ; 422 affichée dans la modale, rien n'est créé. */
function ModalImportScenario({open, onClose, onImporte}) {
    const [file, setFile] = useState(null);
    const [erreur, setErreur] = useState(null);
    const [importer, {isLoading}] = useImporterSimulationMutation();

    const fermer = () => {
        setFile(null);
        setErreur(null);
        onClose();
    };
    const choisir = (e) => {
        const f = e.target.files?.[0] || null;
        setFile(f);
        setErreur(f ? erreurFichierImport(f) : null);
    };
    const envoyer = async () => {
        try {
            const r = await importerScenario((f) => importer(formDataImport(f)).unwrap(), file);
            if (r.erreur) {
                setErreur(r.erreur);
                return;
            }
            toastHelper.displaySuccess('Scénario importé, calcul en cours.');
            onImporte?.(r.cree);
            fermer();
        } catch (e) {
            toastHelper.handleError(e, "Oops, une erreur est survenue.");
        }
    };

    return (
        <Dialog open={open} onClose={fermer} fullWidth maxWidth="sm">
            <DialogTitle>Importer un scénario</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{mb: 2}}>
                    Fichier .json produit par « Exporter » (5 Mo au plus). Le scénario est recalculé sur la photographie
                    du patrimoine embarquée dans le fichier, pas sur le patrimoine actuel.
                </Typography>
                <Button component="label" variant="outlined" color="primary">
                    {file ? file.name : 'Choisir un fichier .json'}
                    <input type="file" hidden accept=".json,application/json" onChange={choisir}/>
                </Button>
                {erreur && <Alert severity="error" sx={{mt: 2}} data-testid="erreur-import">{erreur}</Alert>}
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={fermer}>Annuler</Button>
                <Button color="secondary" variant="contained" sx={{color: 'white', borderRadius: 999, textTransform: 'none', fontWeight: 700}} disabled={!file || isLoading || Boolean(erreurFichierImport(file))}
                        onClick={envoyer} startIcon={isLoading ? <CircularProgress size={22} color="inherit"/> : null}>
                    Importer
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ModalImportScenario;
